import React, { Component } from "react";
import { Select } from "antd";
import { provinceData, cityData } from "../../utils/cityOption";

const Option = Select.Option;

class AreaDropdown extends Component {
  state = {
    cities: cityData[provinceData[0]],
    secondCity: cityData[provinceData[0]][0]
  };

  handleProvinceChange = value => {
    this.setState(
      {
        cities: cityData[value],
        secondCity: cityData[value][0]
      },
      () => {
        this.props.setProvinceCity(value, this.state.secondCity);
      }
    );
  };

  onSecondCityChange = value => {
    this.setState(
      {
        secondCity: value
      },
      () => {
        this.props.setProvinceCity(null, this.state.secondCity);
      }
    );
  };

  render() {
    const { cities } = this.state;
    return (
      <div>
        <Select
          defaultValue={provinceData[0]}
          style={{ width: 120 }}
          onChange={this.handleProvinceChange}
        >
          {provinceData.map(province => (
            <Option key={province}>{province}</Option>
          ))}
        </Select>
        <Select
          style={{ width: 120 }}
          value={this.state.secondCity}
          onChange={this.onSecondCityChange}
        >
          {cities.map(city => (
            <Option key={city}>{city}</Option>
          ))}
        </Select>
      </div>
    );
  }
}

export default AreaDropdown;
